"use client"

import * as React from "react"
import { X } from "lucide-react"
import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"

interface RenameAppModalProps {
  renamingAppId: string | null
  onClose: () => void
  renamingAppInput: string
  setRenamingAppInput: (input: string) => void
  handleSaveRenameApp: () => void
}

export function RenameAppModal({
  renamingAppId,
  onClose,
  renamingAppInput,
  setRenamingAppInput,
  handleSaveRenameApp,
}: RenameAppModalProps) {
  if (!renamingAppId) return null

  return (
    <div className="fixed inset-0 z-55 flex items-center justify-center bg-black/60 backdrop-blur-xs font-sans">
      <Card className="w-full max-w-sm border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6 shadow-2xl rounded-2xl space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-sm font-bold text-zinc-900 dark:text-white flex items-center gap-2">
            <span>✏️</span> Renomear Aplicativo
          </h3>
          <button
            onClick={onClose}
            className="text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-200 cursor-pointer p-1 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors"
          >
            <X className="size-4" />
          </button>
        </div>
        <div className="space-y-2">
          <label className="text-[10px] font-bold text-zinc-400 dark:text-zinc-500 uppercase tracking-wider">
            Novo Nome:
          </label>
          <input
            type="text"
            value={renamingAppInput}
            onChange={(e) => setRenamingAppInput(e.target.value)}
            className="w-full rounded-lg border border-zinc-200 dark:border-zinc-800 px-3 py-2 text-xs dark:bg-zinc-950 dark:text-white focus:outline-none focus:ring-1 focus:ring-[#004EB1]"
            placeholder="Digite o novo nome..."
            autoFocus
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSaveRenameApp()
              if (e.key === "Escape") onClose()
            }}
          />
        </div>
        <div className="flex justify-end gap-2 border-t border-zinc-100 dark:border-zinc-800 pt-4">
          <Button variant="outline" onClick={onClose} className="text-xs py-1.5 px-4 cursor-pointer">
            Cancelar
          </Button>
          <Button
            onClick={handleSaveRenameApp}
            className="bg-[#004EB1] hover:bg-[#003d8d] text-white text-xs font-semibold py-1.5 px-4 cursor-pointer"
          >
            Salvar
          </Button>
        </div>
      </Card>
    </div>
  )
}
